import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {

  fileList = [];

  constructor() { }

  ngOnInit(): void {

    this.fileList = [
      {
        fileName: "碩達系統股份有限公司反賄絡暨經營條款.pdf",
        fileSize: "150KB",
      },
      {
        fileName: "碩達系統股份有限公司行為準則.pdf",
        fileSize: "135KB",
      },
      {
        fileName: "碩達系統股份有限公司員工關懷政策.pdf",
        fileSize: "160KB",
      },
      {
        fileName: "碩達系統股份有限公司隱私保護政策.pdf",
        fileSize: "105KB",
      },
      {
        fileName: "供應商及客戶隱私權保護實行準則.pdf",
        fileSize: "183KB",
      },
      {
        fileName: "碩達系統股份有限公司資訊安全政策.pdf",
        fileSize: "120KB",
      },
      {
        fileName: "碩達簽署及響應淡水河公約宣告.png",
        fileSize: "3,977KB",
      },
      {
        fileName: "2024碩達世界地球日宣導.png",
        fileSize: "1,706KB",
      }
    ];
  }

}
